/** Copyright 2024 SAP SE or an SAP affiliate company. All rights reserved. */
import { useTranslations } from '@/hooks/useTranslations';
import { ThemingParameters } from '@ui5/webcomponents-react-base';
import { DonutChart } from '@ui5/webcomponents-react-charts';

export default function SubscriptionDonutChart({ answerPercentage, launchTriggered }: { answerPercentage: number; launchTriggered: boolean }) {
    const { t } = useTranslations();

    return (
        <DonutChart
            dataset={[
                {
                    name: t('ANSWERED_QUESTIONS'),
                    percentage: answerPercentage,
                },
                {
                    name: t('UNANSWERED_QUESTIONS'),
                    percentage: 100 - answerPercentage,
                },
            ]}
            dimension={{ accessor: 'name' }}
            measure={{
                accessor: 'percentage',
                hideDataLabel: true,

                colors: launchTriggered
                    ? [ThemingParameters.sapProgress_Value_PositiveBackground]
                    : [ThemingParameters.sapProgress_Value_InformationBackground, ThemingParameters.sapProgress_InformationBackground],
                formatter: (value: number) => `${value}%`,
            }}
            style={{ height: 250 }}
            noLegend
            chartConfig={{ margin: { right: 0, left: 0, top: 0, bottom: 0 } }}
        >
            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                style={{
                    fontSize: ThemingParameters.sapFontHeader3Size,
                }}
            >
                {answerPercentage}%
            </text>
            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dy="1.5em"
                style={{ fontFamily: ThemingParameters.sapFontLightFamily, fontSize: ThemingParameters.sapFontLargeSize }}
            >
                {t('ANSWERED')}
            </text>
        </DonutChart>
    );
}
